import {
  AfterViewInit,
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { MatInputModule } from '@angular/material/input'
import { AddressTypeService } from '../../../core/services/address/address-type/address-type.service'
import {
  MatCell,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatRow,
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table'
import { MatIcon } from '@angular/material/icon'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator'
import { generateHexId } from '../../../shared/utils/utils'
import { DriverUploadInsertFormComponent } from './driver-upload-insert-form/driver-upload-insert-form.component'

@Component({
  selector: 'driver-upload-create',
  imports: [
    MatInputModule,
    MatCell,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatIcon,
    MatPaginator,
    MatRow,
    MatTable,
    MatTableModule,
    MatIcon,
    MatPaginatorModule,
    MatTable,
    DriverUploadInsertFormComponent,
  ],
  templateUrl: './driver-upload-create.component.html',
  styleUrl: './driver-upload-create.component.scss',
  providers: [AddressTypeService],
  standalone: true,
})
export class DriverUploadCreateComponent implements OnInit, AfterViewInit {
  constructor() {}

  item: any = {}
  itemsList: any[] = []

  @Output() response: EventEmitter<any> = new EventEmitter()
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined
  @ViewChild(MatTable) table: MatTable<any> | undefined

  columns: any[] = [
    {
      keyColumn: 'contactType',
      key: 'TipoDoc',
      description: 'Tipo Documento',
    },
    {
      keyColumn: 'description',
      key: 'Descricao',
      description: 'Descrição',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ]
  tableSource: MatTableDataSource<any> = new MatTableDataSource<any>()
  displayedColumns: string[] = ['contactType', 'description', 'action']

  ngOnInit(): void {
    this.tableSource = new MatTableDataSource<any>(this.itemsList)
  }

  ngAfterViewInit() {
    this.refreshTable()
  }

  refreshTable() {
    if (this.paginator) {
      this.tableSource.paginator = this.paginator
    }
    if (this.table) {
      this.table.renderRows()
    }
  }

  responseForm(element: any) {
    switch (element.action) {
      case 'create':
        this.includeItem(element.item)
        return
      case 'edit':
        this.updateItem(element.item)
        return
      case 'delete':
        this.deleteItemEvent(element.index)
        return
      case 'cancel':
        this.item = {}
        return
    }
  }

  generateId() {
    let id = generateHexId()
    if (this.itemsList.length == 0) {
      return id
    } else {
      let idDistinct = false
      while (!idDistinct) {
        if (
          this.itemsList.findIndex((ele: any) => {
            return ele.idCreate == id
          }) == -1
        ) {
          idDistinct = true
        } else {
          id = generateHexId()
        }
      }
      return id
    }
  }

  includeItem(element: any) {
    this.itemsList.push({ ...element, idCreate: this.generateId() })
    this.tableSource = new MatTableDataSource<any>(this.itemsList)
    this.refreshTable()
    this.response.emit(this.itemsList)
  }

  updateItem(element: any) {
    let index = this.itemsList.findIndex((ele: any) => {
      return ele.idCreate == element.idCreate
    })
    this.itemsList.splice(index, 1, (({ index, ...rest }) => rest)(element))
    this.tableSource = new MatTableDataSource<any>(this.itemsList)
    this.refreshTable()
    this.item = {}
    this.response.emit(this.itemsList)
  }

  deleteItemEvent(element: any) {
    let index = this.itemsList.findIndex((ele: any) => {
      return ele.idCreate == element.idCreate
    })
    if (index >= 0) {
      this.itemsList.splice(index, 1)
      this.tableSource = new MatTableDataSource<any>(this.itemsList)
      this.refreshTable()
      this.response.emit(this.itemsList)
    }
  }

  selectItemEvent(element: any) {
    this.item = element
  }
}
